/**
 * Hero with Banner Block
 * Handles video background functionality
 */

(function($) {
    'use strict';

    class HeroWithBanner {
        constructor() {
            this.heroBannerBlocks = document.querySelectorAll('.hero-with-banner-block');
            this.init();
        }

        init() {
            if (this.heroBannerBlocks.length === 0) return;

            // Initialize each hero banner block
            this.heroBannerBlocks.forEach((block, index) => {
                this.initializeBlock(block, index);
            });
        }

        initializeBlock(block, index) {
            const heroMp4File = block.querySelector('#hero-banner-mp4-file');
            const heroVideoContainer = block.querySelector('#hero-banner-video-container');
            const heroOverlay = block.querySelector('.hero-video-section .hero-overlay');
            const bgImage = block.querySelector('.hero-video-section .bg-img');

            // Update IDs to be unique if there are multiple blocks
            if (this.heroBannerBlocks.length > 1) {
                if (heroMp4File) heroMp4File.id = `hero-banner-mp4-file-${index}`;
                if (heroVideoContainer) heroVideoContainer.id = `hero-banner-video-container-${index}`;
            }

            // Setup video if container exists and should load video
            if (heroVideoContainer && heroMp4File && this.shouldLoadVideo()) {
                this.setupVideo(heroMp4File, heroVideoContainer, heroOverlay, bgImage);
            }
        }

        shouldLoadVideo() {
            // Only load video on desktop and if user hasn't indicated they prefer reduced motion
            return $(window).width() > 992 && 
                   !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        setupVideo(heroMp4File, heroVideoContainer, heroOverlay, bgImage) {
            if (!heroMp4File || !heroMp4File.value) return;

            const videoElement = this.createVideoElement(heroMp4File);
            this.configureVideo(videoElement);
            this.handleVideoPlayback(videoElement, heroVideoContainer, heroOverlay, bgImage);
        }

        createVideoElement(heroMp4File) {
            const video = document.createElement("video");
            video.className = 'hero-banner-video';
            
            // Add MP4 source
            const sourceMP4 = document.createElement("source");
            sourceMP4.type = "video/mp4";
            sourceMP4.src = heroMp4File.value;
            video.appendChild(sourceMP4);

            return video;
        }

        configureVideo(video) {
            video.autoplay = true;
            video.muted = true;
            video.loop = true;
            video.playsinline = true;
            video.preload = 'metadata';
            
            // Add accessibility attributes
            video.setAttribute('aria-hidden', 'true');
            video.setAttribute('tabindex', '-1');
            
            // Set styles for proper display
            video.style.width = '100%';
            video.style.height = '100%';
            video.style.objectFit = 'cover';
            video.style.objectPosition = 'center';
        }

        handleVideoPlayback(video, heroVideoContainer, heroOverlay, bgImage) {
            const playPromise = video.play();

            if (playPromise !== undefined) {
                playPromise.then(() => {
                    // Video started successfully
                    this.onVideoStarted(heroOverlay);
                }).catch((error) => {
                    console.warn('Hero video autoplay failed:', error);
                    this.onVideoFailed(bgImage);
                });
            }

            // Handle video load events
            video.addEventListener('loadeddata', () => {
                heroVideoContainer.appendChild(video);
                this.hideBackgroundImage(bgImage);
            });

            video.addEventListener('error', () => {
                this.onVideoFailed(bgImage);
            });

            video.load();
        }

        onVideoStarted(heroOverlay) {
            // Hide overlay with animation
            if (heroOverlay) {
                heroOverlay.classList.add('hiding');
                setTimeout(() => {
                    heroOverlay.classList.add('d-none');
                }, 1000);
            }
        }

        onVideoFailed(bgImage) {
            // Show background image as fallback
            if (bgImage) {
                bgImage.classList.remove('d-none');
            }
            console.log('Using background image fallback for hero video');
        }

        hideBackgroundImage(bgImage) {
            // Hide background image when video is ready
            if (bgImage) {
                bgImage.classList.add('d-none');
            }
        }

        // Method to handle window resize
        handleResize() {
            if ($(window).width() <= 992) {
                // Remove videos on mobile and show background images for all blocks
                this.heroBannerBlocks.forEach(block => {
                    const heroVideoContainer = block.querySelector('[id^="hero-banner-video-container"]');
                    const bgImage = block.querySelector('.hero-video-section .bg-img');
                    
                    if (heroVideoContainer && heroVideoContainer.querySelector('video')) {
                        heroVideoContainer.innerHTML = '';
                        if (bgImage) {
                            bgImage.classList.remove('d-none');
                        }
                    }
                });
            }
        }

        // Method to reinitialize videos (useful for dynamic content)
        reinitialize() {
            this.heroBannerBlocks = document.querySelectorAll('.hero-with-banner-block');
            this.init();
        }
    }

    // Initialize when DOM is ready
    $(document).ready(() => {
        const heroWithBanner = new HeroWithBanner();
        
        // Handle window resize
        $(window).on('resize', $.throttle(250, () => {
            heroWithBanner.handleResize();
        }));

        // Expose to global scope for debugging and dynamic content
        window.HeroWithBanner = heroWithBanner;
    });

    // Also initialize on dynamic content load (if using AJAX)
    document.addEventListener('contentLoaded', () => {
        new HeroWithBanner();
    });

    // Throttle function for performance
    $.throttle = function(delay, fn) {
        let timeoutId;
        let lastExec = 0;
        
        return function(...args) {
            const elapsed = Date.now() - lastExec;
            
            const exec = () => {
                lastExec = Date.now();
                fn.apply(this, args);
            };
            
            clearTimeout(timeoutId);
            
            if (elapsed > delay) {
                exec();
            } else {
                timeoutId = setTimeout(exec, delay - elapsed);
            }
        };
    };

}(jQuery));
